import { ActionMenu, type ActionMenuItem } from "@/components/base/ActionMenu";
import type { OrderDocumentKind } from "@/lib/order-documents";

interface PrintDocumentsMenuProps {
  mode?: "single" | "bulk";
  disabled?: boolean;
  includeLabel?: boolean;
  labelAvailable?: boolean;
  onPrint: (kind: OrderDocumentKind) => void;
  onShippingLabel?: () => void;
}

export function PrintDocumentsMenu({
  mode = "bulk",
  disabled,
  includeLabel,
  labelAvailable,
  onPrint,
  onShippingLabel,
}: PrintDocumentsMenuProps) {
  const bulk = mode === "bulk";
  const items: ActionMenuItem[] = [
    { key: "pick", label: bulk ? "Pick slips" : "Pick slip", icon: "ri-list-check-3", onClick: () => onPrint("pick") },
    { key: "pack", label: bulk ? "Packing slips" : "Packing slip", icon: "ri-box-3-line", onClick: () => onPrint("pack") },
    { key: "invoice", label: bulk ? "Tax invoices" : "Tax invoice", icon: "ri-file-text-line", onClick: () => onPrint("invoice") },
  ];
  if (includeLabel) {
    items.push({
      key: "label",
      label: labelAvailable ? "View & print shipping label" : "No shipping label purchased in Tradivo",
      icon: "ri-truck-line",
      onClick: () => onShippingLabel?.(),
    });
  }
  if (disabled) {
    return (
      <button
        type="button"
        disabled
        className="px-4 py-2 bg-white border border-slate-200 text-slate-400 text-sm font-medium rounded-lg whitespace-nowrap flex items-center gap-2 opacity-60"
      >
        Print
      </button>
    );
  }
  return <ActionMenu label="Print" items={items} />;
}
